import { CheckCircle, XCircle, Wrench } from "lucide-react";

export const ColdEmailBestPractices = () => {
  const dos = [
    "Start with 10-20 emails/day and scale slowly over 4-8 weeks",
    "Use multiple domains (3+) to distribute sending load",
    "Personalize the first line with specific research",
    "Send during business hours in recipient's timezone",
    "Keep emails short (50-125 words for first touch)",
    "Use plain text or minimal HTML formatting",
    "Include a clear, low-friction CTA",
    "Monitor deliverability metrics daily",
    "Remove bounces and unsubscribes immediately",
    "A/B test subject lines continuously"
  ];

  const donts = [
    "Never send 200+ emails from a single domain daily",
    "Avoid link-heavy emails (1 link max in cold emails)",
    "Don't use spam trigger words (free, urgent, limited time)",
    "Skip image-heavy templates (text converts better)",
    "Never buy email lists — verify every contact",
    "Don't ignore bounce rates above 5%",
    "Avoid sending to role-based emails (info@, sales@)",
    "Don't use the same template for everyone",
    "Never skip domain warmup for new domains",
    "Don't forget to set up a proper unsubscribe mechanism"
  ];

  return (
    <section className="py-10 sm:py-12">
      <h2 className="font-display text-2xl sm:text-3xl font-bold text-foreground mb-8 text-center">
        Cold Email Best Practices
      </h2>
      
      <div className="grid md:grid-cols-2 gap-6">
        <div className="bg-success/5 border border-success/20 rounded-2xl p-6">
          <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
            <CheckCircle className="w-5 h-5 text-success" />
            Do This
          </h3>
          <ul className="space-y-3">
            {dos.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                <span className="w-1.5 h-1.5 rounded-full bg-success mt-2 flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>
        
        <div className="bg-destructive/5 border border-destructive/20 rounded-2xl p-6">
          <h3 className="font-semibold text-foreground mb-4 flex items-center gap-2">
            <XCircle className="w-5 h-5 text-destructive" />
            Avoid This
          </h3>
          <ul className="space-y-3">
            {donts.map((item, index) => (
              <li key={index} className="flex items-start gap-2 text-sm text-muted-foreground">
                <span className="w-1.5 h-1.5 rounded-full bg-destructive mt-2 flex-shrink-0" />
                {item}
              </li>
            ))}
          </ul>
        </div>
      </div>

      <div className="mt-8 text-center">
        <a 
          href="/tools" 
          className="inline-flex items-center gap-2 px-6 py-3 rounded-xl bg-primary text-primary-foreground font-semibold hover:bg-primary/90 transition-colors"
        >
          <Wrench className="w-5 h-5" />
          Analyze Your Emails
        </a>
        <p className="text-sm text-muted-foreground mt-2">Use our free tools to check deliverability</p>
      </div>
    </section>
  );
};
